module.exports = __webpack_public_path__ + "img/clopotel-notificari.6a686796.svg";